import React from 'react';
import { isProduction } from '@honeybook/utils-web';
function MfeErrorFallback({ appData }) {
    if (isProduction()) {
        return null;
    }
    return (React.createElement("div", { style: { padding: 20, color: 'red' } },
        React.createElement("h2", null,
            "Failed to load remote MFE: ",
            appData.name),
        React.createElement("p", null,
            "Make sure the dev server is running (port",
            ' ',
            appData.devServer?.port,
            ").")));
}
export default MfeErrorFallback;
//# sourceMappingURL=MfeErrorFallback.js.map